<template>
  <b-dropdown
    :variant="isBulkEditMode ? 'primary' : 'secondary'"
    class="ml-1"
    right
  >
    <!-- Contenido del botón principal -->
    <template #button-content>
      <span>{{ $t('bulk_edit.title') }}</span>
      <b-badge
        v-if="isBulkEditMode && selectedCount > 0"
        variant="danger"
        pill
        class="position-absolute"
        style="top: -6px; right: -6px; font-size: 11px; padding: 3px 6px; z-index: 10;"
      >
        {{ selectedCount }}
      </b-badge>
    </template>

    <!-- Sin modo activo: elegir el tipo de selección -->
    <template v-if="!isBulkEditMode">
      <b-dropdown-item @click="$emit('enable-multiselect')">
        <feather-icon icon="CheckSquareIcon" />
        <span class="align-middle ml-50">{{ $t('bulk_edit.multi_select') }}</span>
      </b-dropdown-item>

      <b-dropdown-item @click="$emit('enable-select-all')">
        <feather-icon icon="ListIcon" />
        <span class="align-middle ml-50">{{ $t('bulk_edit.select_all') }}</span>
      </b-dropdown-item>
    </template>

    <!-- Modo activo -->
    <template v-else>
      <b-dropdown-item
        :disabled="!hasSelection"
        @click="$emit('open-bulk-modal')"
      >
        <feather-icon icon="EditIcon" />
        <span class="align-middle ml-50">
          {{ $t('bulk_edit.edit_selected', { count: selectedCount }) }}
        </span>
      </b-dropdown-item>

      <b-dropdown-divider />

      <!-- Cambiar a "seleccionar todo" si aún no está activo -->
      <b-dropdown-item
        v-if="!selectAllMatching"
        @click="$emit('enable-select-all')"
      >
        <feather-icon icon="ListIcon" />
        <span class="align-middle ml-50">{{ $t('bulk_edit.select_all') }}</span>
      </b-dropdown-item>

      <b-dropdown-item @click="$emit('disable-mode')">
        <feather-icon icon="XIcon" />
        <span class="align-middle ml-50">{{ $t('bulk_edit.exit') }}</span>
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
export default {
  name: "BulkEditButton",
  props: {
    isBulkEditMode: {
      type: Boolean,
      required: true,
    },
    selectedCount: {
      type: Number,
      default: 0,
    },
    hasSelection: {
      type: Boolean,
      default: false,
    },
    selectAllMatching: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
